import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";

/**
 * Motivo di refresh della mensa emesso dalle azioni che mutano i dati (command palette,
 * pagina eventi). Il motivo dichiara COSA è cambiato, così ogni consumatore ricarica solo
 * l'area toccata (vedi capability `mensa-refresh-cross-area`):
 * - `evento`             — evento calendario che NON tocca il portafoglio (assenza futura, pasta)
 * - `evento-retroattivo` — ASSENZA che tocca un giorno passato → il BE ricalcola portafoglio+rendicontazione
 * - `ricarica`           — generazione ricarica
 */
export type MensaRefreshReason = 'evento' | 'evento-retroattivo' | 'ricarica';


@Injectable({
  providedIn: 'root'
})
export class GlobalService {

  private readonly _loadedUrl$ = new BehaviorSubject<string>(this.getLoadedUrl());
  readonly loadedUrl$: Observable<string> = this._loadedUrl$.asObservable();

  private readonly _scannerValue$ = new Subject<string>();
  readonly scannerValue$: Observable<string> = this._scannerValue$.asObservable();

  private readonly _nativeFileReceived$ = new Subject<File>();
  readonly nativeFileReceived$: Observable<File> = this._nativeFileReceived$.asObservable();

  private readonly _mensaChanged$ = new Subject<MensaRefreshReason>();
  /** Bus tipizzato fire-and-forget: emissione senza consumatori montati è innocua. */
  readonly mensaChanged$: Observable<MensaRefreshReason> = this._mensaChanged$.asObservable();

  loadedUrl: string = '';
  isMobilePlatform = false;
  appVersion = '';

  constructor() {

  }

  setLoadedUrl(url: string) {
    this.loadedUrl = url;
    this._loadedUrl$.next(this.getLoadedUrl());
  }

  getLoadedUrl(): string {
    return this.loadedUrl;
  }

  nextScannerValue(value: string) {
    this._scannerValue$.next(value);
  }

  nextNativeFileReceived(file: File) {
    this._nativeFileReceived$.next(file);
  }

  emitMensaChanged(reason: MensaRefreshReason) {
    this._mensaChanged$.next(reason);
  }

}
